import { SAVE_SEARCH_PARAMS } from '../actions/saveSearchParams';

export default function searchParamsReducer(
  state: any = null,
  action: any
): any {
  switch (action.type) {
    case SAVE_SEARCH_PARAMS: {
      return action.payload;
    }
    default:
      return state;
  }
}
